export enum COUPON_TYPE {
  COUPON = 'coupon',
  OFFER = 'offer',
}

export interface Coupon {
  couponCode: string;
  couponId: number;
  title: string;
  subTitle: string;
  description: string;
  couponType: number;
  deltaCouponDTO: null;
  discount: number;
  fromDate: string;
  headingText: string;
  couponDetails: { imageUrl: string; couponCode: string };
  infiniteUsage: true;
  label: string;
  offerId: number;
  offerType: string;
  prive: boolean;
  subText: string;
  timesUsed: number;
  toDate: string;
  usesPerCustomer: number;
  expiryEpoch?: number;
  viewProductsFlag?: number;
}

export interface CouponDetails {
  // from api
  couponCode: string;
  couponId: number;
  title: string;
  subTitle: string;
  description: string;
  couponTncUrl: string;
  freebies: any[];
  imageUrl: string;
  prive: boolean;
  subtitle: string;
  tnc: string[];
  // added on code level
  discount: number;
  disabled: boolean;
  expiryEpoch?: number;
}

export interface CouponsList {
  applicableCoupons: Coupon[];
  nonApplicableCoupons: Coupon[];
  appliedCoupon: Coupon[];
}

export interface OfferDetails {
  // from api
  offerId: number;
  title: string;
  description: string;
  label?: string;
  offerDiscount?: string;
  expiryEpoch?: number;
}

export interface BestOffer {
  offerId: number;
  title: string;
  description: string;
  imageUrl: 'string';
  offerType: string;
  expiryEpoch: number;
  offerDiscount: number;
  offerBestPrice: number;
  label: string;
  couponCode: string;
  couponId: string;
  discountType: COUPON_TYPE;
  expiry: string;
  future: boolean;
  isViewProducts: boolean;
}

export interface ApplyCouponCode {
  couponCode: string;
  isCouponCodeEnteredManually: boolean;
}
